import React from 'react'
import styles from './DataCardContentRow.less'
import { FAIcon } from './FAIcon'
import _ from 'common-tools/LodashHelper'
import clsx from 'clsx'

export const DataCardContentRow = ({ children, hasColumns, hide, className }) => {
  if (hide === true) {
    return null
  }
  return <div className={clsx({
    [styles.wrapper]: true,
    [styles.contentColumnRow]: hasColumns
  }, className)}>
    {children}
  </div>
}
DataCardContentRow.DCType = 'ContentRow'

export const DataCardContentRowColumn = ({ children, ellipse, icon = {}, hide }) => {
  if (hide === true) {
    return null
  }
  let faicon

  if (_.has(icon, 'name')) {
    faicon = _.merge({
      name: 'bar',
      type: 'd',
      color: 'purple',
      spin: false,
      toolTip: '',
      placement: 'top',
      size: '18px',
      htmlToolTip: false
    }, icon, { fixedWidth: true })
    return <div className={styles.contentColumn} >
      <FAIcon {...faicon} />
      {children}
    </div>
  } else {
    return <div className={styles.contentColumn} >
      {children}
    </div>
  }
}

export const DataCardSubTitleEclipse = ({ content, width, icon = {} }) => {
  let faicon = _.merge({
    name: 'bar',
    type: 'd',
    color: 'purple',
    spin: false,
    toolTip: '',
    placement: 'top',
    size: '18px',
    htmlToolTip: false
  }, icon, { fixedWidth: true })
  const fixContent = () => {
    return <span className={styles.overflow}>{content}</span>
  }
  const rowStyle = {}
  rowStyle.width = width || 'max-content'
  return <div style={rowStyle} className={styles.contentColumn} >
    {fixContent()}
    <FAIcon {...faicon} />
  </div>
}
